import { Link } from "react-router-dom";
import AppLayout from "@/components/feature/AppLayout";
import SiteFooter from "@/components/feature/SiteFooter";
import AnimeCard from "@/components/feature/AnimeCard";
import EmptyState from "@/components/feature/EmptyState";
import { animeList } from "@/mocks/anime";
import { useFavorites } from "@/hooks/useFavorites";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Favorites() {
  usePageMeta(
    "我的收藏 - 动漫免费在观看",
    "查看你在动漫免费在观看收藏的动漫作品，收藏保存在本地浏览器，随时可以移除或继续浏览。",
    "动漫收藏,我的收藏,动漫在线观看,免费观看动漫",
  );

  const { favorites, removeFavorite } = useFavorites();
  const favoriteAnime = favorites
    .map((id) => animeList.find((item) => item.id === id))
    .filter((item): item is (typeof animeList)[number] => Boolean(item));

  return (
    <AppLayout>
      <div className="px-4 md:px-6 pt-5">
        <header>
          <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2">
            <i className="ri-heart-3-fill text-accent-500" />
            我的收藏
          </h1>
          <p className="mt-1 text-[12.5px] text-foreground-600">
            共收藏 <strong className="text-foreground-900">{favoriteAnime.length}</strong> 部作品 · 收藏记录保存在当前浏览器
          </p>
        </header>

        {favoriteAnime.length ? (
          <>
            <div className="mt-5 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-x-3 gap-y-5">
              {favoriteAnime.map((anime) => (
                <AnimeCard key={anime.id} anime={anime} />
              ))}
            </div>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 px-4 py-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
              <p className="text-[12px] text-foreground-600">
                在作品卡片右上角的心形按钮即可取消收藏，状态会立刻更新。
              </p>
              <Link
                to="/list"
                className="h-8 px-3 rounded-md bg-primary-500 text-background-50 text-[12px] flex items-center gap-1 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-add-line" />
                去发现更多动漫
              </Link>
            </div>
          </>
        ) : (
          <div className="mt-5">
            <EmptyState
              icon="ri-heart-3-line"
              title="收藏夹还是空的"
              description="看到喜欢的作品时，点一下右上角的爱心就能收藏到这里。先去逛逛热门榜单吧。"
            >
              <div className="mt-4 flex flex-wrap justify-center gap-2">
                <Link
                  to="/list?sort=popular"
                  className="h-9 px-4 rounded-md bg-primary-500 text-background-50 text-[13px] flex items-center gap-1.5 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-fire-line" />
                  浏览热门动漫
                </Link>
                <Link
                  to="/search"
                  className="h-9 px-4 rounded-md border border-background-300 text-foreground-800 text-[13px] flex items-center gap-1.5 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-search-line" />
                  搜索动漫
                </Link>
              </div>
            </EmptyState>

            <section className="mt-8">
              <h2 className="font-heading text-base font-bold text-foreground-950 mb-3">大家都在看</h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-x-3 gap-y-5">
                {animeList.slice(0, 5).map((anime) => (
                  <AnimeCard key={anime.id} anime={anime} />
                ))}
              </div>
            </section>
          </div>
        )}

        {favoriteAnime.length ? (
          <div className="mt-8 flex flex-wrap gap-2">
            {favoriteAnime.map((anime) => (
              <button
                key={`remove-${anime.id}`}
                type="button"
                onClick={() => removeFavorite(anime.id)}
                className="h-8 px-3 rounded-full border border-background-300 bg-background-50 text-[11.5px] text-foreground-600 hover:border-accent-400 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
              >
                <i className="ri-close-line" />
                移除「{anime.title}」
              </button>
            ))}
          </div>
        ) : null}
      </div>
      <SiteFooter />
    </AppLayout>
  );
}